import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { useAppDispatch, useAppSelector } from "lib/redux/hooks";
import { selectIsPremiumUser, setIsResumeDownloading } from "lib/redux/uiSlice";
import React, { useState } from "react";

const sanitizeResumeName = (resName: string) => {
  return resName.replace(/\./g, "");
};

const DownloadButton = ({ url, fileName, onDownload, onClose }: any) => {
  const dispatch = useAppDispatch();
  const isPremiumUser = useAppSelector(selectIsPremiumUser);
  const [isCountingDown, setIsCountingDown] = useState(false);
  const [countdown, setCountdown] = useState(3);

  const handleDownload = () => {
    console.log("Download button clicked with URL:", url);
    console.log("File name:", fileName);
    
    if (!url) {
      console.warn("PDF is still generating or failed to generate. URL is null.");
      return;
    }
    
    // Create and click a temporary download link
    const link = document.createElement("a");
    link.href = url;
    link.download = sanitizeResumeName(fileName);
    document.body.appendChild(link);

    Promise.resolve()
      .then(() => {
        link.click();
        return new Promise((resolve) => setTimeout(resolve, 50));
      })
      .then(() => {
        document.body.removeChild(link);
        onClose?.();
      });
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    onDownload?.();

    if (isPremiumUser) {
      // Immediately download the file if the user is premium
      handleDownload();
      return;
    }

    if (isCountingDown) return;

    dispatch(setIsResumeDownloading(true));
    setIsCountingDown(true);
    setCountdown(3);

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setIsCountingDown(false);
          handleDownload();
          dispatch(setIsResumeDownloading(false));
          return 3;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const isDisabled = !url;

  return (
    <a
      className={`btn-gradient border px-4 py-2 text-sm ${
        isDisabled 
          ? 'cursor-not-allowed' 
          : 'cursor-pointer'
      }`}
      onClick={isDisabled ? undefined : handleClick}
      title={isDisabled ? 'PDF is generating, please wait...' : 'Download PDF'}
    >
      <ArrowDownTrayIcon className="h-4 w-4" />
      <span className="whitespace-nowrap">
        Download
      </span>
    </a>
  );
};

export default DownloadButton;